import { jsx as _jsx } from "react/jsx-runtime";
import ErrorComponent from '~components/error';
const NotFound = () => _jsx(ErrorComponent, { message: "Oops, that page cannot be found." });
export default NotFound;
